<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.08 23.51">
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="transport">
        <polyline class="cls-1" points="8.92 10.53 4.79 6.4 4.77 6.39" />
        <polygon
          class="cls-1"
          points="5.45 5.74 4.04 7.16 1.91 6.45 0.5 3.62 1.91 2.21 4.74 3.62 5.45 5.74"
        />
        <path
          class="cls-1"
          d="M15.47,12.84l4.86,4.86a3,3,0,0,1,0,4.24,3,3,0,0,1-4.25,0l-4.85-4.85"
        />
        <path
          class="cls-1"
          d="M11.79,8.05,1.94,17.9a3,3,0,0,0,4.25,4.24l5-5.05,4.24-4.25.55-.55"
        />
        <path class="cls-1" d="M23.37,5A6,6,0,1,1,19.13.71" />
        <polyline
          class="cls-1"
          points="23.37 4.95 20.55 7.2 17.2 6.96 16.87 3.33 19.13 0.71"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
.cls-1 {
  fill: none;
  stroke: #000;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
